import React from 'react'

import { useChartTimeframePathWatch } from '../../use-chart-timeframe-path-watch'

export type QuoteLinksContextType = ReturnType<typeof useChartTimeframePathWatch>

function getDefaultContextValue() {
  const urlObject = new URL(window.location.href)

  return {
    chartLayoutModel: null,
    location: urlObject,
  }
}

export const QuoteLinksContext = React.createContext<QuoteLinksContextType>(getDefaultContextValue())

export function QuoteLinksWrapper({ children }: React.PropsWithChildren<any>) {
  const info = useChartTimeframePathWatch()

  return <QuoteLinksContext.Provider value={info}>{children}</QuoteLinksContext.Provider>
}
